import * as ACTION_TYPES from "../types";

let initialState = {
  loading: false,
  error: false,
  profiles: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.GET_PROFILES:
        return { ...state, profiles: action.data };
      default:
        return state;
    }
  };
